<script>
  import { animate } from 'animejs'

  import { getContext, onMount } from 'svelte'
  import Container from '~/components/ui/container.svelte'

  const page = getContext('work_page')

  onMount(() => {
    animate('.headline-animation .el-animated', {
      rotateX: [90, 0],
      duration: 1 * 1000,
    })
  })
</script>

<section>
  <Container>
    <div class="headline-animation min-h-[30vh] lg:h-auto lg:border-l-2 lg:border-gray-300 lg:px-8">
      <h1 class="el-animated mb-6 text-4xl lg:w-3/6 lg:text-7xl">{page.work.title}</h1>
      <p class="el-animated text-md lg:w-8/12">
        {page.work.descriptionComplete}
      </p>
    </div>

    <hr class="my-[48px]" />
  </Container>
</section>
